<wb-grid>
    <wb-grid-row>
        <wb-grid-col mq6="12" mq5="12" mq4="12" mq3="12" mq2="12" mq1="12">
            <div class="main-error-page" [class.banner-area]="hasBanner">
                <div class="error-content">
                    <div class="error-txt">
                        <h1>{{ error_header | translate }}</h1>
                        <p class="sub-head">
                            {{ error_sub_heading_1 | translate }}
                        </p>
                        @if (error_sub_heading_2) {
                            <p class="sub-head-2">
                                {{ error_sub_heading_2 | translate }}
                            </p>
                        }
                    </div>
                    @if (showTriggerGoToApp) {
                        <div class="publish-btn">
                            <button class="publish-button" (click)="triggerGoToApp()">
                                <span>{{ 'CP_SM_GO_TO_APP' | translate }}</span>
                                @if (showSpinner$) {
                                    <div class="spin-in-btn">
                                        <div class="spinner-border spinner"></div>
                                    </div>
                                }
                            </button>
                        </div>
                    }
                </div>
                <div class="error-image">
                    <picture>
                        <source
                            media="(min-width:1280px)"
                            srcset="../../../../../assets/images/raceShare-error-landscape.png"
                        />
                        <source
                            media="(min-width:768px)"
                            srcset="../../../../../assets/images/raceShare-error-tablet.png"
                        />
                        <source
                            media="(min-width:280px)"
                            srcset="../../../../../assets/images/raceShare-error-portrait.png"
                        />
                        <img
                            src="../../../../../assets/images/raceShare-error-landscape.png"
                            alt="error"
                        />
                    </picture>
                </div>
            </div>
        </wb-grid-col>
    </wb-grid-row>
</wb-grid>
